import {
  DEFAULT_RADIUS_ID,
  DEFAULT_SEARCH_VIEW,
  ITEMS_PER_PAGE,
  MAP_INITIAL_NWLAT,
  MAP_INITIAL_NWLNG,
  MAP_INITIAL_SELAT,
  MAP_INITIAL_SELNG,
  MAP_INITIAL_ZOOM,
} from '@kamernet/constants/Search';
import {
  RentalPriceID,
  RoomAdvertSortOptionID,
  SurfaceMinimumID,
} from '@kamernet/core/ApiClient/Kamernet';

import { ListingsSearchAllFilters } from '../types';

export function getEmptyListingsSearchAllFilters(): ListingsSearchAllFilters {
  return {
    searchCategories: null,
    pageNo: null,
    listingsPerPage: ITEMS_PER_PAGE,
    searchView: DEFAULT_SEARCH_VIEW,
    radius: DEFAULT_RADIUS_ID,
    maxRent: RentalPriceID.Empty,
    minSize: SurfaceMinimumID.Empty,
    citySlug: null,
    cityName: null,
    streetSlug: null,
    streetName: null,
    furnishings: null,
    hasInternet: null,
    isBathroomPrivate: null,
    isKitchenPrivate: null,
    isToiletPrivate: null,
    availabilityPeriods: null,
    availableFrom: null,
    suitableForNumberOfPersons: null,
    suitableForGenders: null,
    suitableForAge: null,
    suitableForWorkStatuses: null,
    isSmokingInsideAllowed: null,
    isPetsInsideAllowed: null,
    roommateNumberMax: null,
    roommateGenders: null,
    ownerTypes: null,
    sort: RoomAdvertSortOptionID.NewestFirst,
    nwlat: MAP_INITIAL_NWLAT,
    nwlng: MAP_INITIAL_NWLNG,
    selat: MAP_INITIAL_SELAT,
    selng: MAP_INITIAL_SELNG,
    mapZoom: MAP_INITIAL_ZOOM,
    mapMarkerLat: 0,
    mapMarkerLng: 0,
  };
}
